<div class="flex flex-col gap-2">
  <taures-message severity="error" header="Deine Anmeldung zum Assessment-Center wurde gelöscht">
    <p>
      Bitte wende dich an {{ this.stateService.getVpManager()?.person?.vorname }} {{ this.stateService.getVpManager()?.person?.nachname }}, um zu
      prüfen, ob ein anderes Datum in Frage kommt.
      <br />
      <br />
      Sobald du für einen anderen Termin vorgemerkt bist, erhältst du von uns eine E-Mail mit dem neuen Termin. Du erreichst das Bewerbungsportal zum
      Einreichen deiner Bewerbung weiterhin über deinen persönlichen Link.
    </p>
  </taures-message>

  <div class="flex justify-end">
    <p-button type="button" [routerLink]="['../landing']" label="Zurück" />
  </div>
</div>
